var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    { attrs: { placement: "bottom", width: "350", trigger: "click" } },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.tabChange },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c("el-tab-pane", {
            attrs: {
              label:
                "全部(" +
                (_vm.pagination.total ? _vm.pagination.total : 0) +
                ")",
              name: "first",
            },
          }),
          _c("el-tab-pane", {
            attrs: {
              label:
                "未读(" +
                (_vm.localPagination.total ? _vm.localPagination.total : 0) +
                ")",
              name: "second",
            },
          }),
        ],
        1
      ),
      _c(
        "el-scrollbar",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { height: "300px" },
        },
        [
          _vm.noticeList.length > 0 && _vm.activeName === "first"
            ? _vm._l(_vm.noticeList, function (item) {
                return _c(
                  "div",
                  {
                    key: item.id + "all",
                    staticClass: "padding-x-5 padding-y-10 notice-item",
                    staticStyle: { cursor: "pointer" },
                    on: {
                      click: function ($event) {
                        return _vm.handleClick(item)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "flex-between margin-bottom-2",
                        staticStyle: { width: "90%" },
                      },
                      [
                        _c("span", { staticClass: "font-14" }, [
                          _vm._v(_vm._s(item.title)),
                        ]),
                        item.readTime
                          ? _c(
                              "el-tag",
                              { attrs: { size: "mini", type: "info" } },
                              [_vm._v("已读")]
                            )
                          : _c(
                              "el-tag",
                              { attrs: { size: "mini", type: "warning" } },
                              [_vm._v("未读")]
                            ),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "one-line" }, [
                      _vm._v(_vm._s(item.remark)),
                    ]),
                    _c("span", { staticClass: "font-12 color-999" }, [
                      _vm._v(_vm._s(item.createTime)),
                    ]),
                  ]
                )
              })
            : _vm._e(),
          _vm.unReadList.length > 0 && _vm.activeName === "second"
            ? _vm._l(_vm.unReadList, function (item) {
                return _c(
                  "div",
                  {
                    key: item.id + "todo",
                    staticClass: "padding-x-5 padding-y-10 notice-item",
                    staticStyle: { cursor: "pointer" },
                    on: {
                      click: function ($event) {
                        return _vm.handleClick(item)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "flex-between margin-bottom-2",
                        staticStyle: { width: "90%" },
                      },
                      [
                        _c("span", { staticClass: "font-14" }, [
                          _vm._v(_vm._s(item.title)),
                        ]),
                      ]
                    ),
                    _c("div", { staticClass: "one-line" }, [
                      _vm._v(_vm._s(item.remark)),
                    ]),
                    _c("span", { staticClass: "font-12 color-999" }, [
                      _vm._v(_vm._s(item.createTime)),
                    ]),
                  ]
                )
              })
            : _vm._e(),
          ((_vm.noticeList.length === 0 && _vm.activeName === "first") ||
            (_vm.unReadList.length === 0 && _vm.activeName === "second")) &&
          !_vm.loading
            ? _c("el-empty", { attrs: { description: "空空如也" } })
            : _vm._e(),
        ],
        2
      ),
      _vm.activeName === "first" &&
      _vm.pagination.pages > 1 &&
      _vm.pagination.page < _vm.pagination.pages
        ? _c(
            "div",
            {
              staticClass: "flex-center padding-top-5",
              on: { click: _vm.loadMore },
            },
            [
              _c("el-button", { attrs: { type: "text" } }, [
                _vm._v("加载更多"),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm.activeName === "second" &&
      _vm.localPagination.pages > 1 &&
      _vm.localPagination.page < _vm.pagination.pages
        ? _c(
            "div",
            {
              staticClass: "flex-center padding-top-5",
              on: { click: _vm.loadMore },
            },
            [
              _c("el-button", { attrs: { type: "text" } }, [
                _vm._v("加载更多"),
              ]),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticStyle: { cursor: "pointer" },
          attrs: { slot: "reference" },
          slot: "reference",
        },
        [
          _c(
            "el-badge",
            {
              attrs: {
                hidden: _vm.localPagination.total === 0,
                value: _vm.localPagination.total,
              },
            },
            [
              _c("div", { staticClass: "flex-center flex-col" }, [
                _c("img", {
                  staticStyle: { width: "22px", height: "22px" },
                  attrs: {
                    src: require("@/static/icon_top_notice.png"),
                    alt: "",
                  },
                }),
                _c("span", { staticClass: "color-666 font-12" }, [
                  _vm._v("消息"),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": "",
            visible: _vm.msgVisible,
            width: "350px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.msgVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "msg-tip-title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [_c("span", [_vm._v(_vm._s(_vm.msgTitle))])]
          ),
          _c(
            "p",
            {
              staticClass: "msg-tip-content",
              staticStyle: { margin: "0 0 0 30px" },
            },
            [_vm._v(_vm._s(_vm.msgContent))]
          ),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "18px" } },
            [
              _c(
                "el-col",
                { attrs: { align: "center" } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { background: "#4292ff" },
                      attrs: { type: "primary", size: "mini" },
                      on: {
                        click: function ($event) {
                          _vm.msgVisible = false
                        },
                      },
                    },
                    [_vm._v("我知道了")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("announcement-dialog", { ref: "announcementDialog" }),
      _c("SettleDetail", { ref: "settle" }),
      _c("LicenseExpireWarning", { ref: "licenseEcpireWarning" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }